import { IProductDetail, IVipPrice } from '@/api/types/public';
import Price from '@/components/Product/Price';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useStore } from '@/providers/app-store-provider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Skeleton } from '@mui/material';
import { usePrevious } from 'ahooks';
import { useTranslations } from '@/i18n/use-translations';
import { useContext, useEffect } from 'react';

const ClientPrice = ({
  product,
  refreshPageData,
  clientRenderReady,
  className,
}: {
  product: IProductDetail;
  refreshPageData: any;
  clientRenderReady: boolean;
  className?: string;
}) => {
  const tPriceA11y = useTranslations('goodsDetail.clientPrice');
  const waiMode = useStore((state) => state.waiMode);
  const { deviceType } = useContext(ResponsiveContext);
  const isWeb = deviceType === EPlatform.WEB;
  // const [productDetail, setProductDetail] = useState<any>(null);

  useEffect(() => {
    const getData = async () => {
      await refreshPageData(false);
    };
    getData();
  }, [product.shop_sku]);

  return !clientRenderReady ? (
    <Skeleton variant="rectangular" width={120} height={45} />
  ) : (
    <Price
      priceObject={product as unknown as IVipPrice}
      renderPrice={(price, sellPrice) => {
        return (
          <div className={`flex items-center ${className || ''}`}>
            <span
              className="text-20 md:text-24 font-bb md:whitespace-nowrap"
              aria-label={tPriceA11y('srCurrent') + sellPrice}
            >
              {sellPrice}
            </span>
            {price && price !== sellPrice && (
              <span
                className={`text-14 ml-8 md:mr-8 line-through ${waiMode ? 'text-primary-black' : ' text-[#a9a9a9]'} md:whitespace-nowrap`}
                style={
                  isWeb
                    ? {
                        fontSize: 'max(.7291666667vw, 11px)',
                      }
                    : {}
                }
              >
                <del aria-label={tPriceA11y('srOriginal') + price}>{price}</del>
              </span>
            )}
          </div>
        );
      }}
    />
  );
};

export default ClientPrice;
